import React, { Component } from 'react';
import { connect } from 'react-redux';
import AceEditor from 'react-ace';
import brace from 'brace';
import 'brace/mode/xml';
import 'brace/theme/xcode';
import prettifyXML from 'prettify-xml';
import LANGUAGES_CONTROLLER from '../../../controllers/languages';
import Logger, {LOG_LEVELS} from '../../../utils/logger';

const log = new Logger('XML_DATA_VIEWER', LOG_LEVELS.DEBUG);
export class XmlDataViewer extends Component {
  render() {
    log.debug('render(): ', this.props);
    log.debug('render(): state', this.state);

    const filename = this.props.filename || '';
    let downloadXML = this.props.prettify ? prettifyXML(this.props.xml): this.props.xml;
    let downloadXMLObjectURL = URL.createObjectURL(new Blob([downloadXML]), {type: "application/octet-stream"});

    return (
      <div data-test="component-xml-data-viewer">
        {
          filename ? (
            <div data-test="download-xml-button">
              <div>
                <a className="button primary" href={downloadXMLObjectURL} download={filename}>
                  {
                    this.props.downloadLabel ? this.props.downloadLabel : LANGUAGES_CONTROLLER.format(this.props.languages,'xmlDataViewer_DownloadButton')
                  } {filename}
                </a>              
              </div>
              <br/>
            </div>  
            
            ) : (<div></div>)
        }

        {
          (this.props.showPreview && this.props.xml) ?
          (
            <div className="xml-viewer overflow-auto">
              <AceEditor
                mode="xml"
                theme="github"
                name="blah2"
                readOnly={true}
                fontSize={12}
                showPrintMargin={false}
                showGutter={true}
                highlightActiveLine={true}
                value={prettifyXML(this.props.xml)}
                width={'100%'}
                height={'100vh'}
                wrapEnabled='true'
                setOptions={{
                enableBasicAutocompletion: false,
                enableLiveAutocompletion: false,
                enableSnippets: false,
                showLineNumbers: false,
                highlightActiveLine:true,
                tabSize: 2,
                }}/>
            </div>
          ) : (<div></div>)
        }
      </div>
    );
  }
  componentDidMount() {
    log.debug('componentDidMount(): ', this.props);
  }
  UNSAFE_componentWillMount() {
    log.debug('componentWillMount(): ', this.props);
  }

}

// Which props do we want to inject, given the global state?
function mapStateToProps(state) {
  log.debug('mapStateToProps: ', state);
  return {
    languages: state.languages
  };
}


XmlDataViewer.defaultProps = {
  showPreview: true,
  showFilenameInDownloadLabel: true
}


// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps)(XmlDataViewer);